<template>
  <div>
    <h2>Informationen</h2>
    <div class="container-fluid mt-4 p-0">
      <div class="row">
        <div class="col-12 mb-4 px-3" v-for="item in getInfos" :key="item.id">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="card-title">
                <span class="text-primary" style="font-size: 1.5rem">{{item.sBezeichnung}}</span>
                <span v-if="item.sBetrifft" class="text-muted" style="font-size: 0.875rem"><br>{{ item.sBetrifft }}</span>
              </div>
              <div class="">
                <div v-if="item.sText">{{ item.sText }}</div>
                <p v-if="item.oFile_arr && item.oFile_arr.length > 0">
                  <span><hr></span>
                  <span v-for="(oFile) in item.oFile_arr" :key="'file' + oFile.id" class="d-block pointer text-primary">
                  <a href="#" v-if="oFile.oDatei" @click="download($event, oFile.oDatei)">
                    <span v-if="oFile.sBezeichnung">{{oFile.sBezeichnung}}</span>
                    <span v-else>{{oFile.oDatei.sFilename}}</span>
                  </a>
                </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TaskService from '../services/TaskService'
  import FileService from '../services/FileService'
  import store from '@/store'

  export default {
    name: 'MyTask',
    components: {},
    async created () {
      var tmp = await TaskService.getMyInfos()
      this.infos = tmp.data
      store.dispatch('menu/setLoading', false)
    },
    data () {
      return {
        infos: []
      }
    },
    methods: {
      download (e, file) {
        e.preventDefault()
        FileService.download(file)
      }
    },
    computed: {
      getInfos () {
        var parsendInfos = []
        this.infos.forEach(function (item) {
          var strArr = [];
          (item.oZustaendigkeit_arr).forEach(function (element) {
            strArr.push(element.sName)
          })

          item.sBetrifft = strArr.join(', ')
          parsendInfos.push(item)
        })
        return parsendInfos
      }
    }
  }
</script>

<style scoped>

</style>
